import { render, staticRenderFns } from "./CallController.vue?vue&type=template&id=3075e2c7&"
import script from "./CallController.vue?vue&type=script&lang=js&"
export * from "./CallController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports